const cookies = {
	CLOSED_UNSUB_ALERT: "CLOSED_UNSUB_ALERT",
	ACP_SESSION: "acp_ss",
	MFA_POSITIVE_DATA_PASSED: "mfa_positive_data_passed",
};

export default cookies;
